export default "__VITE_ASSET__HztvWqlt__"